
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { ElEProjectWiseWorkNameDDLAPI, UpdateWorkNameDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const ElEProjectWiseWorkNameDDL = (props) => {
    const { WorkName, setWorkName, Flag, rowData,ProjectName, IsPost, APIFlag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_ProjectID:ProjectName.ID,
            Flag : APIFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(ElEProjectWiseWorkNameDDLAPI({ data }))
    }, [ProjectName.ID, IsPost])

    const { UpdateWorkNameData } = useSelector(state => state.ElEProjectWiseWorkNameDDLData)

    useEffect(() => {
        handleWorkNameDDL()
    }, [UpdateWorkNameData])

    const handleWorkNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (UpdateWorkNameData && UpdateWorkNameData.table && UpdateWorkNameData.table.length > 0) {
            let list = UpdateWorkNameData.table.map((item, index) => ({
                value: item.m_eleC_WorkID,
                label: item.workName,
            }))
            setWorkName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_eleC_WorkID : 0,
                Label: Flag === 'Update' ? rowData.workName : "Select...",
            })
        }
        else {
            setWorkName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Work Name {Flag && <AstricSign />} </b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkName.ID, label: WorkName.Label }}
                onChange={(e) => {
                    e ?
                        setWorkName({ ...WorkName, ID: e.value, Label: e.label })
                        :
                        setWorkName({ ...WorkName, ID: 0, Label: "Select..." })

                }}
                options={WorkName.DDL}
            />
        </div>
    )
}
